<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2901 17.04L18.0001 15.75V10.75C18.0001 7.68 16.3601 5.11 13.5001 4.43V3.75C13.5001 2.92 12.8301 2.25 12.0001 2.25C11.1701 2.25 10.5001 2.92 10.5001 3.75V4.43C7.63005 5.11 6.00005 7.67 6.00005 10.75V15.75L4.71005 17.04C4.08005 17.67 4.52005 18.75 5.41005 18.75H18.5801C19.4801 18.75 19.9201 17.67 19.2901 17.04ZM16.0001 16.75H8.00005V10.75C8.00005 8.27 9.51005 6.25 12.0001 6.25C14.4901 6.25 16.0001 8.27 16.0001 10.75V16.75ZM12.0001 21.75C13.1001 21.75 14.0001 20.85 14.0001 19.75H10.0001C10.0001 20.85 10.8901 21.75 12.0001 21.75Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Notification'
  }
</script>
